import { createSuspenseQueryHook } from '../internal/createSuspenseQueryHook';
import { teams } from '../queries/teams';

/**
 * @deprecated Use `createQueryOptions` with `getTeam` and `useSuspenseQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const useSuspenseTeam = createSuspenseQueryHook(({ teamKey }: { teamKey: string }) => teams.detail({ teamKey }));
